export default class CopyPricingItem {
  constructor(pricingDetailId) {
    this.PricingDetailId = pricingDetailId;
    this.SelectedPricings = [];
  }

  PricingDetailId = 0;
  SelectedPricings = [];

  setIdList(selectedList) {
    const selectedIds = [];
    selectedList.forEach((emp) => {
      if (emp.SelectedInList) {
        selectedIds.push(emp.PricingId);
      }
    });
    this.SelectedPricings = selectedIds;
  }
}
